

import React, { useEffect, useMemo, useState } from 'react';
import { Card, CardBody, Col, Container, } from 'reactstrap';
import TableContainer from 'Components/Common/TableContainer';
import { useJobDayQuery, useBasinFindAllQuery } from 'store';
import Spinners from "Components/Common/Spinner";
import Breadcrumb from 'Components/Common/Breadcrumb';


const Detail = () => {
  const [customQuery, setCustomQuery] = useState<any>();
  const [logData, setLogData] = useState<any>();
  const [logList, setLogList] = useState<any>();
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();
  const [isLoading, setLoading] = useState<any>(true);

  const {
    data: logListData,
    error: logListDataError,
    isFetching: islogListDataFetching,
    refetch,
  } = useJobDayQuery();

  useEffect(() => {
    setLogData(logListData?.data)
    setLogList(logData?.rows)
  }, [logListData, logData])


  const columns = useMemo(
    () => [
      {
        header: '№',
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Ажилтан овог",
        accessorKey: "lname",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Ажилтан нэр",
        accessorKey: "fname",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Компани",
        accessorKey: "organization_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Хэлтэс",
        accessorKey: "department_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Төрөл",
        accessorKey: "table_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Зассан',
        accessorKey: "updated_cnt",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Устгасан',
        accessorKey: "deleted_cnt",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Шинээр нэмсэн',
        accessorKey: "created_cnt",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Огноо',
        accessorKey: "change_date",
        enableColumnFilter: false,
        enableSorting: true,
      }],
    []
  );
  return (
    <React.Fragment>
      <Col xl={12}>
        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={logList || ""}
              isCustomPageSize={true}
              // isGlobalFilter={true}
              isPagination={true}
              colWidth={3}
              // SearchPlaceholder="Сав газар хайх . . ."
              tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
              pagination="pagination"
              paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            />
          </CardBody>
        </Card>
      </Col>

    </React.Fragment >
  );
}

export default Detail;